import { Box, Chip, styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

/* ------------------ filter main page ----------------*/
export const FilterContainer = styled(Box)({
  borderTop: '1px solid #E1E4E7'
});

export const FilterLocationSelect = styled(Box)({
  minHeight: 88,
  padding: 16
});

/* ------------------ filter chips container ----------------*/
export const FilterChipsContainer = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'left',
  padding: '6px 12px 0px 12px',
  gap: '4px',
  width: '100%'
});

export const FilterTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    maxWidth: 200
  }
}));

export const FilterChip = styled(Chip)({
  maxWidth: 142,
  borderRadius: 4,
  color: '#0259AB',
  borderColor: 'rgba(6, 117, 221, 0.5)',
  deleteIconColor: '',
  '& .MuiChip-deleteIcon': {
    color: '#0259AB',
    fontSize: 'small'
  }
});
